
<div>
  <h5 class="mt-2 mb-4">{{ $t('launch.chat.message') }}</h5>

  <div v-if="getChatWidgetConfiguration" class="row mb-5 ml-2">
    <h6 :class="textColorClass">{{ $t('launch.chat.toggle') }}</h6>
    <cvt-switch
      size="sm"
      color="active"
      type="circular"
      description-type="default"
      :initial-state="chatToggleState"
      mode="LIGHT"
      @switchToggle="onSwitchToggle"
    />
  </div>
  <p v-if="!getChatWidgetConfiguration">
    {{ $t('launch.chat.disabled_message') }}
  </p>
</div>
